import { connect } from 'react-redux';
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import AcceptanceMetric from './AcceptanceMetric';
import { metricPieceTypesList, metricPieceData } from '../../../store/actions/metric';
import {
  getReportCreateNew,
  getReportErrorClose
} from '../../../store/actions/report';
import { modalErrorOpen } from '../../../store/actions/modalError';

const mapStateToProps = ({
  metricReducer,
  reportReducer,
  stockReducer,
  tabsReducer
}) => ({
  metricReducer,
  reportReducer,
  stockReducer,
  tabsReducer
});
const mapDispatchToProps = {
  getReportCreateNew,
  getReportErrorClose,
  modalErrorOpen,
  metricPieceTypesList,
  metricPieceData
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AcceptanceMetric);
